import { Route, Routes } from 'react-router-dom';

import ScrollToHash from './components/ScrollToHash';
import MainLayout from './layout/MainLayout';
import Counter from './pages/Counter';
import Home from './pages/Home';
import MojitoMixer from './pages/MojitoMixer';
import NotFound from './pages/NotFound';
import Privacy from './pages/Privacy';
import Team from './pages/Team';
import TrustCenter from './pages/TrustCenter';
import Weather from './pages/Weather';

export default function App() {
  return (
    <>
      <ScrollToHash />
      <MainLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mix" element={<MojitoMixer />} />
          <Route path="/team" element={<Team />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/trust" element={<TrustCenter />} />
          <Route path="/counter" element={<Counter />} />
          <Route path="/weather" element={<Weather />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </MainLayout>
    </>
  );
}
